import { LegalPage } from "./LegalPage";

export function PrivacyPage() {
  return <LegalPage kind="privacy" fallbackTitle="Privacy Policy" />;
}
